export enum PatientConsentsApplicationName {
  CarequalityConsent = 'carequality-consent',
  ImmunizationRegistryConsent = 'immunization-registry-consent',
}
